export default __webpack_public_path__ + "static/media/animation.21f74913.mp4";